import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function FormatReleaseUpsert(param: any) {
    console.log(param)
    let [FormatRelease, setFormatRelease] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            FormatRelease = param?.editDataDawer
            setFormatRelease(FormatRelease)
        }
    }

    const onSave = () => {
        systemFormatsList.saveFormatRelease(FormatRelease).then((respond: any) => {
            CommonUtilities.showToastDawer('Account Status Saved', 'Success')
        })
    }
    return (<>

        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll' size={800}>
            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Format Release</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="alert alert-danger hide">There was a problem submitting your request, one or more fields are missing or incorrect.</div>

                        <div className="form-format ws-6">
                            <label className="control-label">Release Number*</label>
                            <div className="label-entries">
                                <input type="number" placeholder="Enter Release Number" data-ng-model="formatRel.relNum" required id="relNum" name="relNum" />
                            </div>
                        </div>
                        <div className="form-format ws-6">
                            <label className="control-label"> Release Description *</label>
                            <div className="label-entries">
                                <input type="text" placeholder="Enter Release Description" data-ng-model="formatRel.releaseDesc" required id="releaseDesc" name="releaseDesc" />
                            </div>
                        </div>

                    </div>

                </div>
                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>

            </div>

        </Drawer>
    </>)
}